import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IntlMessages from "util/IntlMessages";
import { userSignIn, forceSignOut } from "actions/Auth";
import CircularProgress from "@material-ui/core/CircularProgress";
import MFACheckPoint from "./MFACheck.jsx";
import Alert from "@material-ui/lab/Alert";
import { tokenDecode } from "../util/Common";
import { Grid } from "@material-ui/core";

const SignIn = (props) => {

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(null);
  const [open, setOpen] = useState(false);
  const [tmpUser, settmpUser] = useState(null);
  const { tempToken, mfa, token } = useSelector(({ auth }) => auth);
  const { loading, message, error } = useSelector(
    ({ commonData }) => commonData,
  );
  const { history } = props;

  useEffect(() => {
    const { valid } = mfa;
    if (token !== null && valid) {
      history.push("/");
    }
  }, [token, mfa, props]);

  useEffect(() => {
    //Multi-factor authentication
    if (tempToken !== null) {
      let _info = tokenDecode(tempToken);
      let _user = typeof _info === "string" ? JSON.parse(_info) : _info;
      settmpUser(_user);
      if (_user && _user.MFA_TYPE !== null) {
        setOpen(!open);
      }
    }
  }, [tempToken]);

  //Stop goBack();
  useEffect(() => {
    window.addEventListener("popstate", () => {
      history.go(1);
    });
  }, []);

  const handleMFAClose = () => {
    setOpen(!open);
  };


  // const noMFA = () => {
  //   return <></>;
  // }

  return (
    //alert(error),
    <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="app-login-main-content">
        {
          open == true ?
            <div className="app-logo-content d-flex align-items-center justify-content-center">
              <MFACheckPoint
                user={tmpUser}
                open={open}
                history={history}
                handleClose={handleMFAClose}
              /></div>
            : <Grid container
              spacing={1}>
              <div className="app-logo-content d-flex align-items-center justify-content-center">
                <Link
                  className="logo-lg"
                  to="/"
                  title="FVS"
                  onClick={(e) => e.preventDefault()}
                >
                  <img
                    style={{ paddingBottom: 5 }}
                    src={require("assets/images/logo.jpg")}
                    alt="FVS"
                    title="FVS"
                  />
                  <br />
                  <span style={{ fontSize: 16, color: "#fff" }}>
                    <center>
                      <IntlMessages id="app.name" />
                    </center>
                  </span>
                </Link>
              </div>

              <div className="app-login-content">
                <div className="app-login-header mb-2">
                  <h1>
                    <IntlMessages id="appModule.userLogin" />
                  </h1>
                  <h1>
                    {(error && (
                      <Alert style={{ fontWeight: "bold" }} severity="error">
                        {error}
                      </Alert>
                    )) ||
                      null}
                  </h1>
                </div>
                <div className="app-login-form">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      dispatch(
                        userSignIn({
                          email,
                          password,
                        }),
                      );
                    }}
                  >

                    <TextField
                      label={<IntlMessages id="appModule.username" />}
                      fullWidth
                      onChange={(event) => setEmail(event.target.value)}
                      defaultValue={email}
                      margin="dense"
                      variant="outlined"
                      className="mt-1 my-sm-2"
                    />
                    <TextField
                      type="password"
                      label={<IntlMessages id="appModule.password" />}
                      fullWidth
                      onChange={(event) => setPassword(event.target.value)}
                      defaultValue={password}
                      margin="dense"
                      variant="outlined"
                      className="mt-1 my-sm-2"
                    />

                    <div className="mb-3 mt-2 d-flex align-items-center justify-content-between">
                      {(error !==
                        "User already signed in other device. Please Sign out first" && (
                          <Button
                            // onClick={() => {
                            //  e.preventDefault();
                            //   dispatch(userSignIn({ email, password }));
                            // }}
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={loading}
                          >
                            {(loading && <CircularProgress size={20} />) || (
                              <IntlMessages id="appModule.signIn" />
                            )}
                          </Button>
                        )) || (
                          <Link
                            className="btn btn-secondary"
                            variant="contained"
                            disabled={loading}
                            color="secondary"
                            onClick={() => {
                              dispatch(forceSignOut({ email, password }));
                            }}
                          >
                            {(loading && <CircularProgress size={20} />) || (
                              <IntlMessages id="appModule.forceSignIn" />
                            )}
                          </Link>
                        )}

                      <Link to="/forgotpassword" className="btn btn-light">
                        <IntlMessages id="signIn.forgotPassword" />
                      </Link>
                      {open && (
                        <MFACheckPoint
                          user={tmpUser}
                          open={open}
                          history={history}
                          handleClose={handleMFAClose}
                        />
                      )}
                    </div>
                  </form>
                </div>
                {/* <Box>
          <Copyright />
        </Box> */}
              </div>
            </Grid>
        }

      </div>
    </div>
  );
};

export default SignIn;
